module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAjCAQAAADGHxlkAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfhCAkOECO+jyjlAAAAdklEQVRIx2NgwAv+7/4PAbuxyzMxUAQGVjsLkeqU/pdDWasZ7xFtOjzoEMBl8PidTtr3MEIBQzlyQhoajh/VTm3tWMF/F4yMMuxLm/8uDMYMDAwMDEpkaWcwZugYSn6ncUHtyrhn8Dqeqn4/y1CBJk98hTT0AABp00EWtVaoqQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icn_sound_on.png
// module id = 38
// module chunks = 0